const types = {
  headingXXL: 'headingXXL',
  headingXL: 'headingXL',
  headingL: 'headingL',
  subHeading: 'subHeading',
  // body fonts
  textLead: 'textLead',
  textBasis: 'textBasis',
  textBasisMedium: 'textBasisMedium',
  textBasisBold: 'textBasisBold',
  textSmall: 'textSmall',
  textSmallMedium: 'textSmallMedium',
  textExtraSmall: 'textExtraSmall',
  textExtraSmallMedium: 'textExtraSmallMedium',
};

export default types;
